import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../Assets/Logos/white-Logo.svg";
import { FaUserCircle, FaSignOutAlt } from "react-icons/fa";
import "./AuthNavbar.css";
import { FaCircleUser } from "react-icons/fa6";

const AuthNavbar = ({ setIsSidebarOpen }) => {
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLogoClick = () => {
    if (window.innerWidth < 1024) {
      setIsSidebarOpen((prevState) => !prevState);
    }
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false); // close dropdown
      }
    };

    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <nav className="bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor shadow-lg fixed top-0 w-full px-3 py-2 text-white z-50">
      <div className="px-3 mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <img
            src={logo}
            alt="Logo"
            className="h-12 w-auto cursor-pointer"
            onClick={handleLogoClick}
          />
        </div>

        <div className="relative">
          <button
            onClick={toggleDropdown}
            className="flex items-center space-x-2 bg-white bg-opacity-10 backdrop-blur-md px-3 py-2 rounded-full hover:bg-opacity-20 transition duration-300 focus:outline-none"
            type="button"
          >
            <FaCircleUser size={40} className="text-white cursor-pointer" />
            <svg
              className={`w-3 h-3 transform transition-transform duration-200 ${
                isDropdownOpen ? "rotate-180" : ""
              }`}
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 4 4 4-4"
              />
            </svg>
          </button>

          {/* Dropdown menu */}
          {isDropdownOpen && (
            <div
              ref={dropdownRef}
              className="absolute right-0 mt-3 w-52 bg-white rounded-2xl shadow-xl overflow-hidden z-50 border border-gray-200 animate-slideDown"
            >
              <div className="p-4 bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor text-white font-semibold">
                Account
              </div>
              <ul className="py-2 text-gray-700">
                <li>
                  <Link
                    to="/profile"
                    onClick={() => setIsDropdownOpen(false)}
                    className="flex items-center px-4 py-2 hover:bg-primaryBtnColor hover:text-white rounded-lg transition-colors duration-300"
                  >
                    <FaUserCircle className="mr-2" size={16} />
                    Profile
                  </Link>
                </li>
                <li>
                  <div
                    onClick={() => {
                      handleLogout();
                      setIsDropdownOpen(false);
                    }}
                    className="flex items-center px-4 py-2 hover:bg-red-500 hover:text-white rounded-lg transition-colors duration-300 cursor-pointer"
                  >
                    <FaSignOutAlt className="mr-2" size={16} />
                    Sign out
                  </div>
                </li>
              </ul>
            </div>
          )}

          {/* Inline CSS for animation */}
          <style>
            {`
      @keyframes slideDown {
        0% { opacity: 0; transform: translateY(-10px); }
        100% { opacity: 1; transform: translateY(0); }
      }

      .animate-slideDown {
        animation: slideDown 0.3s ease-out forwards;
      }
    `}
          </style>
        </div>
      </div>
    </nav>
  );
};

export default AuthNavbar;